import moment from "moment"

import { ILaundryService } from "components/templates/LaundryTemplate/LaundryTemplateTypes"

import { ILaundryFormInitialValues } from "utils/constants"

interface FormatCreateUpdateLaundryDataArgs {
  formData: any
  formValues: ILaundryFormInitialValues
  coordinates: any
  selectedAdditionalServices: number[]
  serviceData: ILaundryService
  discountTypes: { id: number; name: string }[]
}

export const formatCreateUpdateLaundryData = ({
  formData,
  formValues,
  coordinates,
  selectedAdditionalServices,
  serviceData,
  discountTypes,
}: FormatCreateUpdateLaundryDataArgs) => {
  formData.append("name", formValues.name)
  formData.append("address", formValues.address)
  formData.append("phoneNumber", formValues.phone)
  formData.append("idNumber", formValues.idNumber)
  formData.append("bankAccount", formValues.bankAccount)
  formData.append("email", formValues.email)
  formData.append("boxCount", formValues.boxes)
  formData.append("districtId", formValues.district)
  formData.append("workStartTime", moment(formValues.startTime).utc().format())
  formData.append("workEndTime", moment(formValues.endTime).utc().format())
  formData.append("Is24Houres", formValues.is24)

  formData.append("locationLatitude", coordinates?.lat)
  formData.append("locationLongitude", coordinates?.lng)

  selectedAdditionalServices.forEach((additionalService) => {
    formData.append("additionalServices", additionalService)
  })

  discountTypes.forEach((discountType, index) => {
    formData.append(`discountTypes[${index}].id`, discountType.id.toString())
    formData.append(`discountTypes[${index}].name`, discountType.name)
  })

  let i = 0
  for (const key in serviceData) {
    const vehicleBodyType = key.split("-")[0]
    const vehicleBodyTypeId = parseInt(
      //@ts-expect-error
      vehicleBodyType && vehicleBodyType?.match(/\d+/)[0],
      10,
    )
    const washType = key.split("-")[1]
    const match = washType.match(/\d+/)
    const washTypeId = match ? parseInt(match[0], 10) : null
    formData.append(`washprices[${i}].vehicleBodyTypeId`, vehicleBodyTypeId)
    formData.append(`washprices[${i}].washTypeId`, washTypeId)
    formData.append(`washprices[${i}].washTime`, serviceData[key].time)
    formData.append(`washprices[${i}].price`, serviceData[key].price)

    i++
  }

  return formData
}
